/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define(['./ExploreToDashboardConverter'
], function(ExploreToDashboardConverter) {
	class ExploreToStoryConverter extends ExploreToDashboardConverter {
		constructor(definition) {
			super(Object.assign({
				src: 'EXPLORE',
				target: 'STORY'
			}, definition));
		}
		convert(src, target, spec) {
			// ExploreToDashboardConverter does everything we need.
			return super.convert(src, target, spec);
		}
	}
	return ExploreToStoryConverter;
});
